import React, {useRef} from 'react';
import Navbar from "../Navbar/Navbar";
import classes from './Seventhen.module.scss'
import Fotter from "../Fotter/Fotter";
import {Carousel} from "antd";

function Fivethen() {
    const carouselRef = useRef(null);

    return (<div>

            <div className={classes['aw-container']}>
                <Navbar/>
                <div className={classes['aw-section-one']}>
                    <h3>AW17</h3>
                    <div className={classes['aw-image']}></div>
                </div>
                <div className={classes['sections']}>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['child-img']}></div>
                        <h2>Range</h2>
                        <p>25 km</p>

                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['weight-img']}></div>
                        <h2>Weight</h2>
                        <p>7.2 kg</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['time-img']}></div>
                        <h2>Flight time</h2>
                        <p>20-25 min</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['altitude-img']}></div>
                        <h2>Maximum altitude</h2>
                        <p>4000 m</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['speed-img']}></div>
                        <h2>Speed</h2>
                        <p>90-110 km/h</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['payload-img']}></div>
                        <h2>Payload</h2>
                        <p>Warhead 3 kg</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['lunch-img']}></div>
                        <h2>Launch</h2>
                        <p>Catapult</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['landing-img']}></div>
                        <h2>Landing</h2>
                        <p>1.7 m</p>
                    </div>

                </div>
                <div className={classes['paragraph-section']}>
                    <div className={classes['p-Container']}>
                        <h2 className={classes['h']} style={{fontSize: '34px', marginTop: '40px'}}> Key Features</h2>

                        <p><ul>
                            <li>
                                Aircraft-type portable attack UAV (kamikaze).
                                Designed to hit targets at a distance of up to
                                25 km.
                            </li>
                        </ul>
                                <br/>
                             <ul>
                                 <li>
                                     Secure radio communication.
                                     The launch is carried out from a compact
                                     pneumatic or powder catapult.
                                 </li>
                             </ul>
                                <br/>
                               <ul><li>
                                   Hitting a target is possible in two ways: direct
                                   control by the operator and by automatic
                                   tracking of the specified object.
                               </li>
                               </ul>
                                <br/>

                            <ul><li>
                                For easy of storage and transportation, the
                                wing and stabilizer are removable.
                            </li>
                                </ul>
                                </p>



                        <div className={classes['paragraph-small-container']}>
                            {/*<div className={classes['paragraph-small']}>KEY FEATURES</div>*/}
                            {/*<div className={classes['paragraph-small']}>KEY FEATURES</div>*/}
                        </div>


                    </div>
                </div>


                <div
                    style={{width: '80%', height: '55vh', margin: 'auto', marginBottom: '350px', position: 'relative'}}>
                    {/* Navigation Buttons */}
                    <button
                        onClick={() => carouselRef.current?.prev()}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: 10,
                            transform: 'translateY(-50%)',
                            fontSize: '24px',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    >
                        &#60;
                    </button>
                    <button
                        onClick={() => carouselRef.current?.next()}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: 10,
                            transform: 'translateY(-50%)',
                            fontSize: '24px',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    >
                        &#62;
                    </button>

                    {/* Carousel */}
                    <Carousel ref={carouselRef} autoplay dots={true}>
                        <div>
                            <img src="https://i.imgur.com/0DM1i68.png" alt="slide 1"
                                 style={{width: '100%', height: 'auto'}}/>
                        </div>
                        <div>
                            <img src="https://i.imgur.com/bbAggWi.png" alt="slide 2"
                                 style={{width: '100%', height: 'auto'}}/>
                        </div>
                        <div>
                            <img src="https://i.imgur.com/RiKHnvc.png" alt="slide 3"
                                 style={{width: '100%', height: 'auto'}}/>
                        </div>
                    </Carousel>

                    {/* IGES Viewer */}
                </div>
                <div className={classes['product-section']}>
                    <span>AW17 - DATA SHEET</span>
                    <a
                        href='https://drive.google.com/uc?export=download&id=1Bvu3kLysfvTEt97RpcSE4fGt24fiwdFy'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button>Download</button>
                    </a>
                </div>
                <Fotter/>
            </div>


        </div>

    );
}

export default Fivethen;
